export default __webpack_public_path__ + "static/media/kitchen5-afterA-480w.ea1c8c21.png";